import styles from "./index.module.scss";
import { useNavigate } from "react-router-dom";
import classes from "classnames";

export interface ChallengePlanProps {
  cover: string;
  title: string;
  description: string;
  courseNo: string;
  className?: string;
}

const ChallengePlan = ({
  cover,
  title,
  description,
  courseNo,
  className,
}: ChallengePlanProps) => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate(`/challenges-group/${courseNo}`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div className={classes(styles.plan, className)} onClick={handleRedirect}>
      <img src={cover} className={styles.cover} alt="" />
      <div className={styles.main}>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
};

export default ChallengePlan;
